
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<input id=\"{{ id }}\" type=\"checkbox\" class=\"show-password\" aria-controls=\"{{ targetId }}\" tabindex=\"-1\" data-novalue data-synchronize-show=\"{{ synchronizeShow }}\"/>\n<label for=\"{{ id }}\" class=\"show-password-label\" title=\"{{#t}}Show password{{/t}}\">{{#t}}Show password{{/t}}</label>\n"
      return mustache.render(src, view, partials);
    };
  